<template>
    <v-dialog v-model="shows" width="960" persistent>
        <template #activator="{attrs,on}">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card>
            <v-card-title class="align-baseline">
                응찰내역
                <span class="subtitle-2 ml-2"> ({{ workName }}) </span>
                <v-spacer />
                <v-icon @click="shows = false">mdi-close</v-icon>
            </v-card-title>
            <v-divider />
            <v-expand-transition leave-absolute>
                <v-skeleton-loader v-show="loading" type="image@2" width="100%" />
            </v-expand-transition>
            <v-expand-transition leave-absolute>
                <v-card-text v-show="!loading" class="pa-0" style="max-height: calc(90vh - 120px); overflow-y: auto">
                    <v-row no-gutters align="stretch" style="min-height:347px">
                        <v-col>
                            <v-data-table v-model="selected" v-bind="{ items, headers }" show-select :items-per-page="5" single-select @click:row="select">
                                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value }"> {{ header.formatter(value) }} </template>
                                <template #[`item.meta.username`]="{item, value}">
                                    {{ value }}
                                    <v-chip v-if="work?.price_auction?._bid == item._id" small class="rounded-0 font-weight-light pa-1" outlined color="black">
                                        <template v-if="work.isSoldOut">구매자</template>
                                        <template v-else-if="work.isAuctionEnded">낙찰자</template>
                                        <template v-else>최고가</template>
                                    </v-chip>
                                </template>
                            </v-data-table>
                        </v-col>
                        <v-col cols="auto">
                            <v-divider vertical />
                        </v-col>
                        <v-col class="user-table">
                            <v-card-subtitle> 응찰자 정보 </v-card-subtitle>
                            <v-divider />
                            <template v-if="selected?.[0]?.user?.type == PERSON?.value">
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.name" label="이름" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.bornAt?.toDate?.()" type="date" label="생년월일" persistent-placeholder hide-details readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.sex" label="성별" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.nation" label="국가" persistent-placeholder hide-details readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.occupation" label="직업" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.companyName" label="직장" persistent-placeholder hide-details readonly />
                                    </v-col>
                                </v-row>
                            </template>
                            <template v-if="selected?.[0]?.user?.type == COMPANY?.value">
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.name" label="기업명" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.foundAt?.toDate?.()" label="기업설립일" persistent-placeholder hide-details readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.businessRegisitrationNumber" label="사업자등록번호" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.nation" label="국가" persistent-placeholder hide-details readonly />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.ceoName" label="대표자명" persistent-placeholder hide-details readonly />
                                    </v-col>
                                    <v-col cols="auto"> <v-divider vertical /> </v-col>
                                    <v-col>
                                        <v-text-field :value="selected?.[0]?.user?.website" label="홈페이지주소" persistent-placeholder hide-details readonly>
                                            <template #append>
                                                <v-btn text icon small class="mr-2" @click="window.open(selected?.[0]?.user?.website, '_blank')">
                                                    <v-icon>mdi-link</v-icon>
                                                </v-btn>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-expand-transition>
            <v-divider />
            <v-card-actions>
                <v-btn color="secondary">선택한 응찰로 낙찰 변경</v-btn>
                <v-spacer />
                <v-btn color="primary">판매완료 처리</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
import { USER_TYPES } from "@/assets/variables";
const { PERSON, COMPANY } = USER_TYPES;
const headers = [
    { text: "응찰자", value: "meta.username" },
    { text: "응찰가", value: "price", formatter: (value) => `${value?.format?.() || value} 원` },
    { text: "응찰시간", value: "createdAt", formatter: (value) => value?.toDateTime?.() },
];
export default {
    props: {
        work: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
        loading: false,

        bids: [],
        headers,
        selected: [],

        window,
        PERSON,
        COMPANY,
    }),
    computed: {
        workName() {
            const { author, year, subject } = this.work;
            return `${author?.nameTag?.ko || "작가미상"} - ${year} - ${subject}`;
        },
        items() {
            return (this.bids || []).map((bid) => ({ ...bid, isSuccess: bid._id == this.work.price_auction?._bid }));
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        shows() {
            this.init();
        },
        items() {
            const selected = this.items.find(({ isSuccess }) => isSuccess);
            if (selected) this.selected = [selected];
        },
    },
    methods: {
        init() {
            if (this.shows) this.search();
        },
        async search() {
            this.loading = true;
            const { bids } = await api.console.auction.works.bids.gets({ _work: this.work._id });
            this.bids = bids;
            this.loading = false;
        },
        select(item) {
            this.selected = [item];
        },
    },
};
</script>

<style lang="scss" scoped>
.user-table {
    ::v-deep input {
        padding: 8px 12px;
        max-height: initial;
    }

    ::v-deep label {
        margin-left: 4px;
    }

    ::v-deep .v-input__slot::before {
        border-color: rgba(0, 0, 0, 0.12) !important;
    }
}
::v-deep tr {
    cursor: pointer;
}
</style>
